module.exports = __webpack_public_path__ + "assets/avatar_icon.b626f75b.svg";